import { UntypedFormGroup } from "@angular/forms";
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import moment, { Moment } from "moment";

export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export function loadDateToMoment(strDate : string | Date | undefined) {
  if (strDate) {
    return moment(strDate);
  } else {
    return null;
  }
}

// the to date field min validation error may happen even if its value is later than 1900/1/1 as the min value error will also return
// if the to date is earlier than from date.
// so if min validator error exists, first check its value is less than 1900/1/1, if so show regular 1900 error
// if to date is over 1900 but still get min validator error, then the from date must has a later date then to date, in this case, retur
// true for both from and to date

export function datePickerValidationCheckImpl(form: UntypedFormGroup, field: string, validationType: string): boolean {
 /* if (field != 'dob') {
    console.log("************date field valid called -- *" + field);
    console.log( field + " form control value: " + form.get(field)?.value?.format("YYYY-MM-DD"));
    console.log(field + " form control valid: " + form.get(field)?.valid);
    console.log(field + " form control touched: " + form.get(field)?.touched);
     
    console.log(field + " form errors "+ JSON.stringify(form.get(field)?.errors));
  }*/

  let isTouched = form.get(field)?.touched;
  let formatError = form.get(field)?.hasError('matDatepickerParse');
  let required =  form.get(field)?.hasError('required') && isTouched && (!formatError);
  let minDate = form.get(field)?.hasError('matDatepickerMin');
  let futureDate = form.get(field)?.hasError('matDatepickerMax');
  let minAge16 = form.get(field)?.hasError('minAge');
  let val = form.get(field)?.value as moment.Moment;

  let anyError = false;

  switch(validationType) {
    case 'required': {
      if (required) {
        return true;
      }
      return false;
    } 
    case 'matDatepickerParse': {
      if (formatError) {
        return true;
      }
      return false;
    } 
    case 'matDatepickerMin': {
      // min validator may also failed on startEnd validation, 
      // so only show the error is before 1900/1/1 as well.
      if (minDate) {
        if (val.isBefore(moment('1900-1-1'))) {
          return true;
        }
      }
      return false;
    } 
    case 'matDatepickerMax': {
      if (futureDate) {
        return true;
      }
      return false;
    }
    case 'startEndError': {
      // show start end error only if to day is in valid range (1900-1-1 to today),
      // otherwise, the more specific validation message pre-1900 or future date should show
      let startFieldControl;
      if (field == "yourBusinessTo") {
        startFieldControl = form.get("yourBusinessFrom");
      } else if (field == "employedTo") {
        startFieldControl = form.get("employedFrom");
      }
      let toValue = form.get(field)?.value as moment.Moment;
      if (startFieldControl?.valid && toValue?.isAfter(moment('1900-1-1')) && toValue?.isBefore(moment()) &&
        minDate) {
          return true;
      }
      return false;
    }
    case 'minAge': {
      if (minAge16) {
        return true;
      }
      return false;
    }
    case 'any': {
      if ( required || formatError || minDate || futureDate || minAge16) {
        return true;
      }
      return false;
    }
    default:
       return false;
  }
}